<form class="db-other" [formGroup]="otherForm">
  <div class="db-other-wrap">
    <div class="db-other-wrap-title">{{!messageSent ? ('text_setupOtherStepTitle' | dbText) : ('text_setupOtherStepSuccessTitle' | dbText)}}</div>
    <div class="db-other-wrap-name" [innerHTML]="!messageSent ? '' : ('text_setupOtherStepSuccessDesc' | dbText)"></div>
    <div class="db-other-wrap-desc" [ngClass]="{'db-other-wrap-desc-success': messageSent}" [innerHTML]="!messageSent ? ('text_setupOtherStepDesc' | dbText) : ('text_setupOtherStepSuccessDescFooter' | dbText)"></div>
    <div class="db-other-wrap-type">
      <div>
        <label class="db-inner-label">
          <div>
            <p>{{"text_setupOtherStepPluginsQuestion" | dbText}}</p>
            <span [innerHTML]="'text_setupOtherStepPluginsQuestionDesc' | dbText"></span>
          </div>
          <div class="db-main-section__radio">
            <input class="ds-radio" type="radio" name="otherType" id="plugins" formControlName="otherType" value="plugins">
            <label for="plugins"></label>
          </div>
        </label>
      </div>
      <div>
        <label class="db-inner-label">
          <div>
            <p>{{"text_setupOtherStepOtherQuestion" | dbText}}</p>
            <span [innerHTML]="'text_setupOtherStepOtherQuestionDesc' | dbText"></span>
          </div>
          <div class="db-main-section__radio">
            <input class="ds-radio" type="radio" name="otherType" id="other" formControlName="otherType" value="other">
            <label for="other"></label>
          </div>
        </label>
      </div>
    </div>
    <div class="db-other-wrap-body" *ngIf="!messageSent" [ngClass]="{'show': otherForm.controls['otherType'].valid}">
      <p>{{'text_setupOtherStepTextareaDesc' | dbText}}</p>
      <textarea formControlName="message" placeholder="Tell us what we can do to personalize 10Web for you"></textarea>
      <div>
        <button class="ds-btn-blue"
                [disabled]="!otherForm.controls['message'].valid &&  otherForm.controls['message'].value === ''"
                [ngClass]="{'ds-btn-disabled': !otherForm.controls['message'].valid && otherForm.controls['message'].value !== ''}"
                (click)="submit()">
          <span *ngIf="!loading">{{"text_forgotPasswordSubmit" | dbText | lowerCaseSpecificWords}}</span>
          <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
        </button>
      </div>
    </div>
    <div class="db-other-wrap-footer" *ngIf="messageSent">
      <div class="db-other-wrap-footer">
        <button class="ds-btn-blue ds-btn-l"
                [disabled]="!otherForm.controls['message'].valid &&  otherForm.controls['message'].value === ''"
                [ngClass]="{'ds-btn-disabled': !otherForm.controls['message'].valid && otherForm.controls['message'].value !== ''}"
                (click)="submit()">
          <span *ngIf="!loading">{{"text_addWebsiteManuallyStep5Title1" | dbText}}</span>
          <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
        </button>
      </div>
    </div>
  </div>
</form>
